import { render, staticRenderFns } from "./DFTable.vue?vue&type=template&id=4244f1dd&"
import script from "./DFTable.vue?vue&type=script&lang=js&"
export * from "./DFTable.vue?vue&type=script&lang=js&"
import style0 from "./DFTable.vue?vue&type=style&index=0&id=4244f1dd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports